// extracted by mini-css-extract-plugin
module.exports = {"skill__container":"skillCardAlternative_skill__container___suvs","skill__layer":"skillCardAlternative_skill__layer__rStnr"};